import * as Sentry from "@sentry/vue"

let sentryInitialized = false

export function initSentry(app) {
  const dsn = process.env.VUE_APP_SENTRY_DSN
  const isProductionEnvironment = !process.env.VUE_APP_DEVELOPMENT_MODE

  if (sentryInitialized || !dsn || !isProductionEnvironment) {
    return
  }

  Sentry.init({
    app,
    dsn,
    release: typeof GIT_COMMIT_HASH !== "undefined" ? GIT_COMMIT_HASH : undefined,
    environment: process.env.VUE_APP_DEVELOPMENT_MODE || process.env.NODE_ENV || "development",
    integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    tracesSampleRate: 0.1,
    beforeSend(event) {
      const level = event.level || "error"
      if (level === "log" || level === "info" || level === "debug") {
        return null
      }
      return event
    }
  })

  sentryInitialized = true
}

export function setSentryUserContext(user, tenant) {
  const client = Sentry.getCurrentHub().getClient()
  if (!client) {
    return
  }

  if (!user) {
    Sentry.setUser(null)
    Sentry.setTag("tenantId", undefined)
    return
  }

  const userContext = {}
  if (user.id) {
    userContext.id = user.id
  }
  if (user.email) {
    userContext.email = user.email
  }
  if (user.displayName) {
    userContext.username = user.displayName
  }

  const tenantId = tenant && (tenant.id || tenant.companyId || tenant.tenantCompanyId)
  if (tenantId) {
    userContext.tenantId = tenantId
  }

  Sentry.setUser(userContext)

  Sentry.setTag("tenantId", tenantId || "unset")
}
